import React, { FC } from 'react';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import { OrderProductType, OrderType } from 'src/types/order';
import FileUpload, { CustomFileActions, FilesPropType } from 'src/components/FileUpload';
import EntityFilesTable from 'src/components/FileUpload/EntityFilesTable';
import { FileType } from 'src/types/file';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { EditKeysType, ProductEditKeysType } from './constants';
import TextField from 'src/components/TextField';
import { Block } from './FilesBlock';
import { OnChangeType } from '../../types/global';

export interface OrderProductDetailPropsType {
    editData: OrderType;
    openProductDetailId: number;
    onClose: () => void;
    onChange: OnChangeType<EditKeysType>;
    disableEdit?: boolean;
    orderProductFileTypeCodes: ConstantsCodeType[];
    orderProductCustomizationTypeCodes: ConstantsCodeType[];
    allowOrderFiles: boolean;
    skladonUser?: number;
}

const OrderProductDetail: FC<OrderProductDetailPropsType> = (props) => {
    const orderProduct =
        props.editData.ORDER_PRODUCTS?.find(
            (product) => Number(product.ORDERS_PRODUCTS_ID) === Number(props.openProductDetailId)
        ) || null;

    const handleChangeFile = (value: FilesPropType, error: boolean) => {
        const newProduct = props.editData.ORDER_PRODUCTS?.map((product) => {
            if (product.ORDERS_PRODUCTS_ID === Number(props.openProductDetailId)) {
                return { ...product, FILES: value.map((file) => ({ ...file, type: 'other' })) };
            }
            return product;
        });
        props.onChange('ORDER_PRODUCTS', newProduct, false);
    };

    const changeValue = (key: ProductEditKeysType, value: any, error: boolean) => {
        const newProduct = props.editData.ORDER_PRODUCTS?.map((product) => {
            if (product.ORDERS_PRODUCTS_ID === Number(props.openProductDetailId)) {
                const newProductData = { ...product };
                newProductData[key] = value;
                return newProductData;
            }
            return product;
        });
        props.onChange('ORDER_PRODUCTS', newProduct, false);
    };

    const handleChangeType = (value: any, error: boolean, inputFile: FileType, inputName: string) => {
        const newProduct = props.editData.ORDER_PRODUCTS?.map((product) => {
            if (product.ORDERS_PRODUCTS_ID === Number(props.openProductDetailId)) {
                return {
                    ...product,
                    FILES: product.FILES?.map((file) => (file === inputFile ? { ...file, type: value } : file)),
                };
            }
            return product;
        });
        props.onChange('ORDER_PRODUCTS', newProduct, false);
    };

    const customFileActions: CustomFileActions = (inputFile) => {
        const inputName = `file-type-${inputFile.fileName}`;
        return (
            <Select
                options={props.orderProductFileTypeCodes}
                value={inputFile.type}
                onChange={(value, error) => handleChangeType(value, error, inputFile, inputName)}
                name={inputName}
                required
                fullWidth
                disabled={props.disableEdit}
            />
        );
    };

    return (
        <Dialog
            onClose={props.onClose}
            maxWidth="xl"
            title={translate('orderDetail.titleOrderProductDetail')}
            fullWidth
        >
            <Grid>
                <GridItem cols={6}>
                    <Select
                        options={props.orderProductCustomizationTypeCodes}
                        value={orderProduct?.CUSTOMIZATION_TYPE}
                        onChange={(value, error) => changeValue('CUSTOMIZATION_TYPE', value || null, error)}
                        name="CUSTOMIZATION_TYPE"
                        label={translate('orderDetail.productTable.customizationType')}
                        fullWidth
                        disabled={props.disableEdit}
                        emptyOption
                    />
                </GridItem>
                <GridItem cols={6}>
                    <TextField
                        value={orderProduct?.CUSTOMIZATION_TEXT}
                        onChange={(value, error) => changeValue('CUSTOMIZATION_TEXT', value, error)}
                        name="CUSTOMIZATION_TEXT"
                        label={translate('orderDetail.productTable.customizationText')}
                        fullWidth
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={6}>
                    <TextField
                        value={orderProduct?.LOT}
                        onChange={(value, error) => changeValue('LOT', value, error)}
                        name="LOT"
                        label={translate('orderDetail.productTable.LOT')}
                        fullWidth
                        disabled={props.disableEdit}
                    />
                </GridItem>
            </Grid>
            <Block>
                {/*{props.allowOrderFiles && (*/}
                    <FileUpload
                        files={orderProduct?.FILES || []}
                        onChange={(value, error) => handleChangeFile(value, error)}
                        // accept=".pdf,.xlsx,.doc,.docx,.txt,.pptx"
                        name="PRODUCT.FILES"
                        // error={props.editErrors.FILES}
                        height={130}
                        disabled={props.disableEdit}
                        multiple
                        displayFilesList={false}
                    />
                    <EntityFilesTable
                        files={orderProduct?.FILES || []}
                        disabled={!!props.disableEdit}
                        onDeleteFile={(file) => {
                            handleChangeFile(
                                (orderProduct?.FILES || []).filter((f) => f !== file),
                                false
                            );
                        }}
                        skladonUser={props.skladonUser}
                        customFileActions={customFileActions}
                        testIdPrefix="order-product-files"
                    />
                {/*)}*/}
            </Block>
        </Dialog>
    );
};

export default OrderProductDetail;
